<template>
  <div>
    <el-dialog
      title = "上传数据"
      :visible.sync = "visible"
      :close-on-click-model="false"
      @close="dialogClose"
      append-to-body
      :width="`${900}px`"
    >
      <div class="search_group">
        <el-input style="width: 220px" size="small" v-model="formChild.search" clearable placeholder="请输入项目名称"></el-input>
        <el-button @click="getList" icon="el-icon-search" size="small" type="success">查询</el-button>
        <el-button @click="showUploadDialog = true" icon="el-icon-upload" size="small" type="primary">上传</el-button>
        <el-button icon="el-icon-delete" size="small" type="danger" @click="deleteUploadData">删除</el-button>
      </div>
      <el-table :max-height="tableHeight"
        v-loading="listLoading" element-loading-text="加载中" border 
        @selection-change="handleSelectionChange"
        :data="tableData">
        <el-table-column align="center" type="selection" width="55"></el-table-column>
        <el-table-column align="center" fixed prop="orderNo" label="项目编号" width="200"></el-table-column>
        <el-table-column align="left" label="项目名称" width="200">
          <template slot-scope="scope">
          <span>{{ scope.row.parentId > 0 ? '【子项目】': ''}}{{scope.row.orderName}}</span>
        </template>
        </el-table-column>
        <el-table-column align="left" label="原始订单">
          <template slot-scope="scope">
            <el-button type="text" @click="downloadOrgin(scope.row)" >{{ scope.row.sfileName }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table_pagination">
        <el-pagination class="app-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize" :layout="paginationLayout" :total="totalEl">
        </el-pagination>
      </div>
      <uploadDialog :uploadDialogFlag.sync="showUploadDialog" :dataType="dataType" :editId="projectInfo.id"></uploadDialog>
    </el-dialog>
  </div>
</template>
<script>
import { settleDetailOrders, deleteOrgData } from '@/api/projectSettlement/procedure'
import pagination from '@/util/mixins/pagination'
import uploadDialog from './uploadDialog.vue'
export default {
  mixins: [pagination],
  props: {
    orginalOrderDialogFlag: {
      type: Boolean,
      default: false
    },
    projectInfo: {
      type: Object,
      default: () => {}
    },
    editId: {
      type: String,
      default: ''
    },
    editType: {
      type: String,
      default: () => ''
    }
  },
  components: {
    uploadDialog
  },
  data() {
    return {
      visible: false,
      dataType: 2, // 上传的数据类型
      showDetails: false, // 详情弹窗
      selectProject: [],
      formChild: {
        search: ''
      },
      showUploadDialog: false // 显示上传的弹窗
    }
  },
  mounted () {
  },
  methods: {
    dialogClose() {
      this.$emit('update:orginalOrderDialogFlag', false)
    },
    onSearch() {
      this.pageNo = 1
      this.getList()
    },
    // 获取列表
    getList () {
      this.listLoading = true
      let postData = {
        search: this.formChild.search,
        settleId: this.projectInfo.id,
        current: this.pageNo,
        size: this.pageSize
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.data
          this.totalEl = res.data.data.totalCount
        } else {
          this.$message.error(res.data.msg)
        }
      }
      settleDetailOrders(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 选择项目
    handleSelectionChange(val) {
      this.selectProject = val
    },
    downloadOrgin(row) {
      window.open(row.sfileUrl)
    },
    // 删除上传的订单文件
    deleteUploadData() {
      if(this.selectProject.length > 0) {
        this.$confirm("确定将选择项的原始订单文件删除?","提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          const ids = this.selectProject.map(item => item.id).join(',')
          const formData = new FormData();
          formData.append('ids', ids)
          deleteOrgData(formData).then(res => {
            if(res.data.code === 200 && res.data.success) {
              this.$message.success('删除原始订单文件成功')
              this.getList()
            }
          }).catch(err => {
            this.$message.error(err)
          })
        }).catch(() => {
          console.log('取消删除')
        })
      } else {
        this.$message.warning('请先选择项目')
      }
    },
  },
  watch: {
    orginalOrderDialogFlag() {
      this.visible = this.orginalOrderDialogFlag
      if(this.visible) {
        this.onSearch()
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>